import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TextField, Button, Typography, Alert } from "@mui/material";
import { resetPassword } from "../api/authApi";
import getApiErrorMessage from "../utils/getApiErrorMessage";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await resetPassword(token, newPassword);
      setFeedback({ type: "success", message: res.message });
    } catch (err) {
      setFeedback({
        type: "error",
        message: getApiErrorMessage(err, "Failed to reset password."),
      });
    }
  };

  if (!token) return <Alert severity="error">Invalid or missing reset token.</Alert>;

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: "auto", paddingTop: 100 }}>
      <Typography variant="h5" gutterBottom>
        Reset Password
      </Typography>
      <TextField
        fullWidth
        label="New Password"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        required
        margin="normal"
      />
      <Button fullWidth variant="contained" type="submit">
        Update Password
      </Button>
      {feedback && <Alert severity={feedback.type} sx={{ mt: 2 }}>{feedback.message}</Alert>}
    </form>
  );
}
